module.exports = __webpack_public_path__ + "img/star-map_bg-5.883294b.png";